import React from 'react';
import styles from './TimeIntervalsInfoBlob.module.scss';
import { BlobContainer } from 'components/common';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_INTERACTIVE_AREAS_STORE } from 'store';
import TimeIntervalButton from './TimeIntervalButton';
import { TimeIntervalsInfoBlobProps, Couple } from './types';

const TimeIntervalsInfoBlob = (props: TimeIntervalsInfoBlobProps) => {
  const {
    hide = () => null,
    entityId = null,
    entityClass = null,
    timeIntervals = null,
    [EDITOR_INTERACTIVE_AREAS_STORE]: {
      getInteractiveAreaEvents,
      getInteractiveAreasForEntity
    }
  } = props;

  const getInOutEventCouples = (): Couple[] => {
    let inOutEventCouples = [];
    getInteractiveAreasForEntity(entityId, entityClass)
      .forEach(({ id }) => {
        const thisIaEventCouples = [];

        getInteractiveAreaEvents(id)
          .filter(({ type }) => type !== null)
          .sort((a, b) => a.t - b.t)
          .forEach((event, index) => {
            const coupleIndex = Math.floor(index / 2);
            if (!thisIaEventCouples[coupleIndex]) {
              thisIaEventCouples[coupleIndex] = {};
            }
            thisIaEventCouples[coupleIndex][event.type] = event;
          });
        inOutEventCouples = inOutEventCouples.concat(thisIaEventCouples);
      });
    inOutEventCouples.sort((a, b) => a.I.t - b.I.t);
    return inOutEventCouples;
  };

  return (
    <BlobContainer hide={hide} className={styles.container}>
      {timeIntervals
        ? timeIntervals.map((interval, index) =>
          <TimeIntervalButton
            key={index}
            interval={interval}
          />
        )
        : getInOutEventCouples().map((couple, index) =>
          <TimeIntervalButton
            key={index}
            couple={couple}
          />
        )
      }
    </BlobContainer>
  );
};

export default inject(EDITOR_INTERACTIVE_AREAS_STORE)(observer(TimeIntervalsInfoBlob));
